// Nutrition + Supplement plan data for UMUT ŞAHİN
export const TARGETS = [
  { label: "Kalori", value: "1600", unit: "kcal", icon: "Flame" },
  { label: "Protein", value: "165", unit: "gr", icon: "Beef" },
  { label: "Karbonhidrat", value: "118", unit: "gr", icon: "Wheat" },
  { label: "Yağ", value: "44", unit: "gr", icon: "Droplet" },
];

export const MEALS = [
  {
    key: "kahvalti",
    time: "07:00 — 09:00",
    title: "Kahvaltı",
    icon: "Sunrise",
    items: [
      "3 Tam Yumurta",
      "4 Yumurta Beyazı",
      "2 Dilim Tam Buğday Ekmeği",
      "Domates, Salatalık, Yeşillik",
    ],
    alternatives: ["Lor Peyniri", "Az Yağlı Beyaz Peynir", "Menemen", "Omlet"],
    macros: { protein: 38, carbs: 25, fat: 16 },
  },
  {
    key: "ara1",
    time: "10:30 — 11:30",
    title: "Ara Öğün",
    icon: "Apple",
    items: ["1 Ölçek Whey Protein", "1 Adet Orta Boy Elma"],
    alternatives: ["Armut", "Portakal", "Şeftali"],
    macros: { protein: 24, carbs: 20, fat: 2 },
  },
  {
    key: "ogle",
    time: "13:00 — 14:00",
    title: "Öğle Yemeği",
    icon: "Sun",
    items: ["200 gr Tavuk Göğüs", "180 gr Pişmiş Pirinç Pilavı", "Büyük Salata"],
    alternatives: ["Hindi", "Yağsız Dana Eti", "Ton Balığı"],
    extraAlt: { label: "Sebze Alternatifleri", items: ["Brokoli", "Kabak", "Karnabahar", "Fasulye"] },
    macros: { protein: 50, carbs: 50, fat: 5 },
  },
  {
    key: "ara2",
    time: "16:00 — 17:00",
    title: "Ara Öğün",
    icon: "Coffee",
    items: ["200 gr Yüksek Proteinli Yoğurt"],
    alternatives: ["Kefir", "Süzme Yoğurt"],
    macros: { protein: 20, carbs: 8, fat: 3 },
  },
  {
    key: "aksam",
    time: "19:00 — 20:30",
    title: "Akşam Yemeği",
    icon: "Moon",
    items: [
      "200 gr Yağsız Dana Eti veya Tavuk",
      "100 gr Pişmiş Pirinç Pilavı",
      "Büyük Porsiyon Sebze",
    ],
    extraAlt: { label: "Sebze Alternatifleri", items: ["Ispanak", "Semizotu", "Taze Fasulye", "Brokoli", "Kabak"] },
    macros: { protein: 35, carbs: 15, fat: 18 },
  },
];

export const TOTAL = { kcal: 1600, protein: 167, carbs: 118, fat: 44 };

export const SUPPLEMENTS = [
  {
    time: "Sabah",
    icon: "Sunrise",
    items: [
      { name: "D3 + K2", dose: "5000 IU" },
      { name: "Kreatin Monohidrat", dose: "5 gr" },
    ],
  },
  {
    time: "Antrenman Sonrası",
    icon: "Dumbbell",
    items: [{ name: "Whey Protein", dose: "1 Ölçek" }],
  },
  {
    time: "Akşam",
    icon: "Sunset",
    items: [{ name: "Magnezyum Bisglisinat", dose: "300-400 mg" }],
  },
  {
    time: "Yatmadan Önce",
    icon: "Moon",
    items: [{ name: "ZMA", dose: "Önerilen doz" }],
  },
];
